module.exports = __webpack_public_path__ + "img/node-solar-transparent.3087a807.webp";